var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-gray-800",attrs:{"id":"app"}},[(!_vm.$route.meta.hideNavbar)?_c('NavBar'):_vm._e(),_c('router-view'),(!_vm.$route.meta.hideFooter)?_c('TheFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }